export const BRAND_PINK = "#da127d";

export const CONFIG = {
  // Brand
  BRAND_NAME: "MnMukt",
  BRAND_TAGLINE: "Premium Fashion & Lifestyle",
  CURRENCY: "₹",

  // Contact
  contact: {
    phoneDisplay: "+91 99134 19927",
    whatsappNumber: "919913419927",
    whatsappLink: "https://wa.me/919913419927",
    phoneNote: "(WhatsApp Only)",
    email: "mnmuktinfo@gmail.com",
    supportHours: "Mon - Sat | 10:00 AM - 7:00 PM",
  },

  // Support
  support: {
    emailSubject: "Website Support Request",
    defaultMessage:
      "Hi, I visited your website and need help regarding your products.",
  },

  // Shipping / Delivery
  shipping: {
    standardCharge: 60,
    expressCharge: 120,
    freeShippingAbove: 999,
    estimatedDelivery: "3 - 7 Business Days",
    expressDelivery: "1 - 3 Business Days",
    cashOnDelivery: true,
    codCharge: 40,
  },

  // Return / Exchange
  returns: {
    returnDays: 7,
    exchangeDays: 7,
    returnAllowed: true,
    exchangeAllowed: true,
  },

  // Widget
  widget: {
    greeting: "Hi there 👋",
    subtitle: "How can we help you?",
    responseTime: "Usually replies within a few hours",
  },

  // Website Information
  siteInfo: {
    copyright: `© ${new Date().getFullYear()} MnMukt. All rights reserved.`,
    address: "India",
  },

  // Navigation Links
  quickLinks: [
    { label: "About Us", path: "/about-us" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "Blogs", path: "/blogs" },
  ],

  // Policies
  policies: [
    { label: "FAQ", path: "/faq" },
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Terms of Service", path: "/terms-of-service" },
    { label: "Shipping Policy", path: "/shipping-policy" },
    { label: "Exchange & Return Policy", path: "/exchange-return-policy" },
    { label: "Exchange/Return Request", path: "/exchange-return-request" },
    { label: "Product Care", path: "/product-care" },
    { label: "Sitemap", path: "/sitemap" },
  ],

  // Social Media
  socials: [
    {
      name: "Facebook",
      url: "https://facebook.com/yourpage",
    },
    {
      name: "Instagram",
      url: "https://instagram.com/yourprofile",
    },
    {
      name: "WhatsApp",
      url: "https://wa.me/919913419927",
    },
  ],
};
